import React, { createContext, useContext, useEffect, useState } from 'react';
import { api, restoreBearer, setBearer } from './api';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);     // null | object | false
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      const hasToken = !!restoreBearer();
      const path = typeof window !== 'undefined' ? window.location.pathname : '';
      const inAuthArea = /^\/(admin|login)/.test(path);
      // Avoid 401 noise on the public landing: only probe /auth/me when we
      // have either a stored bearer or we are in an auth-protected area
      // (where the httpOnly cookie may grant us a session).
      if (!hasToken && !inAuthArea) {
        if (alive) {
          setUser(false);
          setLoading(false);
        }
        return;
      }
      try {
        const { data } = await api.get('/auth/me');
        if (alive) setUser(data?.user || false);
      } catch {
        if (alive) setUser(false);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    if (data?.access_token) setBearer(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post('/auth/logout'); } catch {}
    setBearer(null);
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, login, logout, loading }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
